import { Tooltip } from 'react-tooltip'
import { PhoneProviderActions } from '../../components/telephony/PhoneProviderActions'

interface AgentInfoTooltipProps {
  id: string
  user: {
    firstName: string
    lastName: string
    email: string
    cellphone?: string | null
  } | null
}

export const AgentInfoTooltip: React.FC<AgentInfoTooltipProps> = ({ id, user }) => {
  // Si no hay usuario, no mostrar tooltip
  if (!user) {
    return (
      <Tooltip
        delayHide={500}
        clickable={true}
        id={id}
        place='bottom'
        className='tooltip-tfi tooltip-clean'
      >
        <div className='tooltip-tfi' style={{ color: '#222' }}>
          <p>No agent assigned</p>
        </div>
      </Tooltip>
    )
  }

  return (
    <Tooltip
      delayHide={500}
      clickable={true}
      id={id}
      place='bottom'
      className='tooltip-tfi tooltip-clean'
    >
      <div className='tooltip-tfi' style={{ color: '#222' }}>
        <h6 className='text-center'>Agent information:</h6>

        <div className='element'>
          <p className='fw-bold'>Name</p>
          <p>{user.firstName} {user.lastName}</p>
        </div>

        <div className='element'>
          <p className='fw-bold'>Email</p>
          <p style={{ maxWidth: '140px', wordBreak: 'break-all' }}>{user.email}</p>
        </div>

        <div className='element'>
          <p className='fw-bold'>Phone</p>
          <PhoneProviderActions phone={user.cellphone} />
        </div>
      </div>
    </Tooltip>
  )
}
